module.exports = __webpack_public_path__ + "media/images/icon__nativeAppShare-77ca425d7d1d9eaf571f5a54d340cb4f.png";